<template>
  <div class="box-login">
    <!-- <div id="qr-code" :title="!isQrcode ? '扫码登录' : '手机号登录'" :class="isQrcode ? 'pc-login' : ''" @click="isQrcode = !isQrcode"></div> -->
    <div class="box-login-main" v-show="!isQrcode">
      <ul class="logo-nav">
        <li
          @click="loginNavClick(index)"
          :class="logoIndex == index ? 'active' : ''"
          v-for="(item, index) in ['快捷登录', '密码登录']"
          :key="item"
        >
          <p>{{ item }}</p>
          <span></span>
        </li>
      </ul>
      <div
        class="register-main-item"
        style="position: relative"
        :class="isPhoneFoucs ? 'isFoucs' : ''"
      >
        <img
          :src="'icon_login_phone.png' | imagePath"
          class="register-main-icon"
        />
        <input
          type="text"
          placeholder="请输入手机号"
          v-model="phone"
          maxlength="11"
          @keyup.13="btnClick"
          @input="phone = phone.replace(/[^\d]/g, '')"
        />
      </div>
      <div
        class="register-main-item"
        v-if="logoIndex == 0"
        :class="isCodeFoucs ? 'isFoucs' : ''"
      >
        <img
          :src="'icon_login_code.png' | imagePath"
          class="register-main-icon"
        />
        <input
          type="text"
          placeholder="请输入验证码"
          v-model="code"
          maxlength="6"
          @keyup.13="btnClick"
          @input="code = code.replace(/[^\d]/g, '')"
        />
        <em @click="getCode()" :class="isSendMessage ? 'grey' : 'pointer'">{{
          sendMessageHtml
        }}</em>
      </div>
      <div
        class="register-main-item"
        v-if="logoIndex == 1"
        :class="isPasswordFoucs ? 'isFoucs' : ''"
      >
        <img
          :src="'icon_login_password.png' | imagePath"
          class="register-main-icon"
        />
        <input
          type="password"
          placeholder="输入密码"
          @keyup.13="btnClick"
          maxlength="16"
          v-model="pass"
        />
        <!-- <p class="register-main-item-warn" v-show="showPassWarn">请输入密码</p> -->
      </div>
      <div
        class="register-read"
        @click="isRead = !isRead"
        v-if="logoIndex !== 1"
      >
        <img
          :src="
            isRead
              ? 'icon_check_pressed.png'
              : 'icon_check_normal.png' | imagePath
          "
        />
        <p>我已阅读并同意</p>
        <strong @click.stop="serviceText(100)">
          《 <a href="javascript:void(0)">用户服务协议</a> 》和
        </strong>
        <strong @click="serviceText(102)">
          《 <a href="javascript:void(0)">隐私协议</a> 》
        </strong>
      </div>
      <div class="register-main-btn" @click="btnClick()">登录</div>
      <!-- <div class="login-warn" v-if="logoIndex == 0">未注册的手机号将自动创建账户，登录即表示您已同意</div> -->
      <div class="login-btn" v-if="logoIndex == 1">
        <span @click="forgetPass">忘记密码?</span>
        <span @click="register">注册账号</span>
      </div>
    </div>
    <div v-show="isQrcode" id="login_container"></div>
    <el-dialog
      :title="dialogTitle"
      custom-class="el-dialog--center"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div v-html="dialogWord"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isPhoneFoucs: false,
      isPasswordFoucs: false,
      isCodeFoucs: false,
      dialogVisible: false,
      dialogWord: "",
      dialogTitle: "",
      // 0注册 1登录 2忘记密码
      // isLogo:this.$route.params.type,
      isRead: true, //是否已阅读条款协议
      // registerSuccess:false,//是否注册成功
      logoIndex: 0, //0快捷登录 1密码登录
      phone: "", //手机号
      pass: "", //密码
      code: "", //验证啊
      isSendMessage: false,
      sendMessageHtml: "获取验证码",
      codeType: 3, //1:绑定手机号 2：换绑手机号 3：快捷登录 4：找回密码 5.用户注册
      systemTime: null,
      copyright_company: "",
      isQrcode: false
    };
  },
  props:{
    error: {
        type: Function,
        default: () => {}
    }
  },
  methods: {
    // 快捷登录与密码登录切换
    loginNavClick(index) {
      this.logoIndex = index;
    },

    //按钮点击事件
    btnClick() {
      this.login();
    },
    // 获取验证码
    getCode() {
      if (this.isSendMessage) return;
      if (!this.$.tool.isPhone(this.phone)) {
        this.$message.warning("请输入正确的手机号");
        return false;
      }
      var data = {
        mobile: this.phone,
        type: this.codeType,
      };
      this.$.http
        .post("sendVerifyCode", data, "发送短信验证码", true)
        .then((res) => {
          this.$message.success("发送成功");
          this.isSendMessage = true;
          var s = 60;
          this.sendMessageHtml = s + " 秒";
          var int = setInterval((res) => {
            if (s <= 1) {
              this.sendMessageHtml = "重新获取验证码";
              this.isSendMessage = false;
              clearInterval(int);
            } else {
              s--;
              this.sendMessageHtml = s + " 秒";
            }
          }, 1000);
        })
        .catch((res) => {
          if (res.code == 20010 || res.code == 20012) {
            this.error()
          }
        });
    },

    // 登录
    login() {
      if (!this.$.tool.isPhone(this.phone)) {
        this.$message.warning("请输入正确的手机号");
        return false;
      }
      if (this.logoIndex == 0) {
        //快捷登录
        var data = {
          mobile: this.phone,
          verify_code: this.code,
        };
        if (this.code == "") {
          this.$message.warning("请输入验证码");
          return false;
        }
        if (!this.isRead) {
          this.$message.warning("请阅读并同意用户协议");
          return false;
        }

        this.$.http.post("loginByMobile", data, "快捷登录").then((res) => {
          this.$emit('sendLogin',this.$.user.userLogin(res.data));
          this.$.notification.emit("login", true);
          if (this.$route.query.from) {
            this.$.router.replace("index");
          }
          if (this.$route.query.fromUrl) {
            var url = "/" + this.$route.query.fromUrl;
            this.$.router.replace(`${url}`);
          } else {
            this.$.router.replace("index");
          }
        });
      } else {
        //密码登录
        var data = {
          mobile: this.phone,
          password: this.pass,
        };
        if (this.pass == "") {
          this.$message.warning("请输入密码");
          return false;
        } else if (this.pass.length < 6 || this.pass.length > 16) {
          this.$message.warning("密码为6-16位，请输入正确的密码");
          return false;
        }
        this.$.http.post("loginByPassWord", data, "密码登录").then((res) => {
          this.$emit('sendLogin',this.$.user.userLogin(res.data));
          this.$.notification.emit("login", true);
          if (this.$route.query.from) {
            this.$.router.replace("index");
          }
          if (this.$route.query.fromUrl) {
            var url = "/" + this.$route.query.fromUrl;
            this.$.router.replace(`${url}`);
          } else {
            this.$.router.replace("index");
          }
          // else if(this.$route.query.fromUrl){
          //   if(this.$route.query.fromUrl.indexOf('?') !== -1){
          //     var url = '/'+this.$route.query.fromUrl.split('?')[0]
          //     var params = this.$route.query.fromUrl.split('?')[1].split('=')[1]
          //      this.$.router.replace(url,{id:params})
          //   } else {
          //     console.info(this.$route.query.fromUrl)
          //     this.$.router.replace(this.$route.query.fromUrl)
          //   }
          // } else {
          //   this.$.router.replace('index')
          // }
        });
      }
    },

    forgetPass() {
      this.$.router.push("forgotPassword");
    },
    // 注册账号
    register() {
      this.$.router.push("register");
    },
    // 服务协议
    getProtocol(type) {
      this.$.http.post("basic/agreement/"+type).then((res) => {
        this.dialogWord = res.data.content;
        this.dialogTitle = res.data.title;
      });
    },
    // 服务协议
    serviceText(type) {
      this.dialogVisible = true;
      this.getProtocol(type);
    },
  },
  mounted(){
    //snsapi_login微信开放平台
    const redirect_uri = encodeURIComponent('https://freely.hanyu365.com.cn/loginAuth')
    const appid = 'wx43d7d287e62553e0'
    var obj = new WxLogin({
        self_redirect: false, //是否iframe形式跳转
        id:"login_container", 
        appid, 
        scope: "snsapi_login", 
        redirect_uri,
        state: "",
        style: "black",
        href: ""
    });
  }
};
</script>

<style scoped>
@import url("../../assets/css/login.css");
.login-btn {
  display: flex;
  width: 280px;
  margin: 30px auto;
  justify-content: space-between;
  color: #777777;
  font-size: 15px;
  cursor: pointer;
}

.logo-nav {
  display: flex;
  justify-content: space-between;
  margin: 0 20px 20px;
}
.logo-nav li {
  font-size: 17px;
  color: #999999;
  margin: 0 15px;
  cursor: pointer;
}
.logo-nav li.active {
  color: #ff3e32;
}
.logo-nav li.active span {
  display: block;
  width: 25px;
  height: 5px;
  background-color: #ff3e32;
  border-radius: 3px;
  margin: 5px auto 0;
}
.box-login-main {
  width: 312px;
  background: #fff;
  padding: 20px;
  height: 300px;
}
#qr-code{
  position: absolute;
  right: 0;
  top: 0;
  width: 54px;
  height: 54px;
  background: url(../../assets/images/qr-code.png) no-repeat center;
  background-size: 54px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  cursor: pointer;
}
#login_container{
  width: 400px;
  height: 400px;
  display: flex;
  justify-content: center;
}
#qr-code.pc-login{
  background: url(../../assets/images/pc-login.png) no-repeat center;
  background-size: 54px;
}
</style>



// WEBPACK FOOTER //
// src/components/BoxLogin/index.vue